import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import project from '@/api/project';
import user from '@/api/user';

const { getProductPrefix: gPP, getProductCategory: gPC, getProductRefType: gPRT, getProductStatus: gPS } = project();
const { getPrivilegeLevels: gPL } = user();

export const getProductPrefix = createAsyncThunk('content/setProductPrefix', async (params) => {
	const response = await gPP(params);
	return (
		response.data?.map((d) => {
			return { ...d, id: d.productprefixid, name: d.productprefixname };
		}) || []
	);
});

export const getProductCategory = createAsyncThunk('content/setProductCategory', async (params) => {
	const response = await gPC(params);
	return response.data || [];
});

export const getProductRefType = createAsyncThunk('content/setProductRefType', async (params) => {
	const response = await gPRT(params);
	return response.data || [];
});

export const getPrivilegeLevels = createAsyncThunk('content/setPrivilegeLevels', async (params) => {
	const response = await gPL(params);
	return response.data || [];
});

export const getProductStatus = createAsyncThunk('content/setProductStatus', async (params) => {
	const response = await gPS(params);
	return response.data || [];
});

const triggerSlice = createSlice({
	name: 'trigger',
	initialState: {
		refetch: null,
		showVideo: null,
		showPublicDetail: null,
		homeReset: false,
	},
	reducers: {
		triggerAPI(state, action) {
			const currState = state;
            const data = action.payload;
            const { key, value } = data
			currState[key] = value;
		},
	},
	extraReducers: () => {},
});

export const contentActions = triggerSlice.actions;
export default triggerSlice;
